module.exports = __webpack_public_path__ + "static/media/4ODA1.dc3f672d.jpg";